import React from 'react'
import screenStyles from './Screen.module.scss'

/** Returns a Presenter Screen with the content type that was passed to it */

const Screen = ({children}) => {

  return <div className={screenStyles[`screen`]} data-bdd={`screen-container`}>
      <div className={screenStyles[`screen__content`]} data-bdd={`talks-screen-content`}>
        {children}
      </div>
    </div>
}

export default Screen
